var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOverdueWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25330",
    "data-name": "Group 25330",
    transform: "translate(-242 -40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25187",
    "data-name": "Group 25187",
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25131",
    "data-name": "Group 25131"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24849",
    "data-name": "Group 24849",
    transform: "translate(241 40)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59",
    "data-name": "Ellipse 59",
    cx: 55,
    cy: 55,
    r: 55,
    fill: "#909"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25130",
    "data-name": "Group 25130",
    transform: "translate(266.01 179.465)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37086",
    "data-name": "Path 37086",
    d: "M21.629-63.007A3.466,3.466,0,0,1,18.367-64.7L16.31-63.362a6.26,6.26,0,0,0,3.483,2.626v1.7h2.448v-1.591c1.653-.337,3.428-1.543,3.636-3.25a3.494,3.494,0,0,0-2.889-3.924c-.7-.214-1.3-.367-1.806-.5-1.4-.367-1.726-.484-2.038-.912a.945.945,0,0,1-.159-.741,1.316,1.316,0,0,1,.612-.839,2.629,2.629,0,0,1,1.891-.1,3.327,3.327,0,0,1,2.093,1.512l2.136-1.224a5.77,5.77,0,0,0-3.477-2.62v-1.726H19.793V-73.4a4,4,0,0,0-1.457.514,3.734,3.734,0,0,0-1.751,2.448,3.36,3.36,0,0,0,.582,2.663c.857,1.175,1.922,1.451,3.4,1.836.477.122,1.041.269,1.7.471,1.181.361,1.255.612,1.175,1.285C23.4-63.766,22.554-63.147,21.629-63.007Z",
    transform: "translate(-5.555 -14.55)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37087",
    "data-name": "Path 37087",
    d: "M56.623-82.283H3.258a1.224,1.224,0,0,1-1.224-1.224,1.224,1.224,0,0,1,1.224-1.224H56.623a1.224,1.224,0,0,1,1.224,1.224A1.225,1.225,0,0,1,56.623-82.283Z",
    transform: "translate(-0.017 -10.758)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25129",
    "data-name": "Group 25129",
    transform: "translate(1.99 -112.465)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37088",
    "data-name": "Path 37088",
    d: "M54.091-103.845H50.3v2.448h3.791a1.838,1.838,0,0,1,1.836,1.836v42.233a1.838,1.838,0,0,1-1.836,1.836H6.275a1.838,1.838,0,0,1-1.836-1.836V-99.56A1.838,1.838,0,0,1,6.275-101.4h4.12v-2.448H6.275A4.289,4.289,0,0,0,1.99-99.56v42.233a4.289,4.289,0,0,0,4.285,4.285H54.091a4.29,4.29,0,0,0,4.285-4.285V-99.56A4.29,4.29,0,0,0,54.091-103.845Z",
    transform: "translate(-1.99 109.121)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2272",
    "data-name": "Rectangle 2272",
    width: 21.367,
    height: 2.448,
    transform: "translate(17.674 5.277)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37089",
    "data-name": "Path 37089",
    d: "M16.945-108.181a3.07,3.07,0,0,1,3.061-3.061h.7a3.07,3.07,0,0,1,3.061,3.061v.992H24.99v-.992a4.29,4.29,0,0,0-4.285-4.285h-.7a4.29,4.29,0,0,0-4.285,4.285v.992h1.224Z",
    transform: "translate(-7.316 112.465)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37090",
    "data-name": "Path 37090",
    d: "M20.006-94.769h.7a4.289,4.289,0,0,0,4.285-4.285v-.791H23.765v.791A3.07,3.07,0,0,1,20.7-95.993h-.7a3.07,3.07,0,0,1-3.061-3.061v-.791H15.721v.791A4.289,4.289,0,0,0,20.006-94.769Z",
    transform: "translate(-7.316 107.57)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2273",
    "data-name": "Rectangle 2273",
    width: 1.224,
    height: 2.448,
    transform: "translate(16.45 5.277)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2274",
    "data-name": "Rectangle 2274",
    width: 1.224,
    height: 2.448,
    transform: "translate(8.405 5.277)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37091",
    "data-name": "Path 37091",
    d: "M20.782-95.993h.7a3.07,3.07,0,0,0,3.061-3.061v-.791H23.317v.791a1.838,1.838,0,0,1-1.836,1.836h-.7a1.839,1.839,0,0,1-1.836-1.836v-.791H17.721v.791A3.07,3.07,0,0,0,20.782-95.993Z",
    transform: "translate(-8.092 107.57)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37092",
    "data-name": "Path 37092",
    d: "M18.945-107.4a1.838,1.838,0,0,1,1.836-1.836h.7a1.838,1.838,0,0,1,1.836,1.836v.992h1.224v-.992a3.07,3.07,0,0,0-3.061-3.061h-.7a3.07,3.07,0,0,0-3.061,3.061v.992h1.224Z",
    transform: "translate(-8.092 111.69)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2275",
    "data-name": "Rectangle 2275",
    width: 1.224,
    height: 2.448,
    transform: "translate(9.629 5.277)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2276",
    "data-name": "Rectangle 2276",
    width: 1.224,
    height: 2.448,
    transform: "translate(15.225 5.277)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37093",
    "data-name": "Path 37093",
    d: "M67-108.181a3.07,3.07,0,0,1,3.061-3.061h.7a3.07,3.07,0,0,1,3.061,3.061v.992H75.04v-.992a4.29,4.29,0,0,0-4.285-4.285h-.7a4.29,4.29,0,0,0-4.285,4.285v.992H67Z",
    transform: "translate(-26.73 112.465)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37094",
    "data-name": "Path 37094",
    d: "M73.815-99.054a3.07,3.07,0,0,1-3.061,3.061h-.7A3.07,3.07,0,0,1,67-99.054v-.791H65.771v.791a4.289,4.289,0,0,0,4.285,4.285h.7a4.29,4.29,0,0,0,4.285-4.285v-.791H73.815Z",
    transform: "translate(-26.73 107.57)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2277",
    "data-name": "Rectangle 2277",
    width: 1.224,
    height: 2.448,
    transform: "translate(47.086 5.277)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2278",
    "data-name": "Rectangle 2278",
    width: 1.224,
    height: 2.448,
    transform: "translate(39.041 5.277)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37095",
    "data-name": "Path 37095",
    d: "M69-107.4a1.838,1.838,0,0,1,1.836-1.836h.7a1.838,1.838,0,0,1,1.836,1.836v.992h1.224v-.992a3.07,3.07,0,0,0-3.061-3.061h-.7a3.07,3.07,0,0,0-3.061,3.061v.992H69Z",
    transform: "translate(-27.506 111.69)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37096",
    "data-name": "Path 37096",
    d: "M70.832-95.993h.7a3.07,3.07,0,0,0,3.061-3.061v-.791H73.367v.791a1.839,1.839,0,0,1-1.836,1.836h-.7A1.838,1.838,0,0,1,69-99.054v-.791H67.771v.791A3.07,3.07,0,0,0,70.832-95.993Z",
    transform: "translate(-27.506 107.57)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2279",
    "data-name": "Rectangle 2279",
    width: 1.224,
    height: 2.448,
    transform: "translate(40.265 5.277)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2280",
    "data-name": "Rectangle 2280",
    width: 1.224,
    height: 2.448,
    transform: "translate(45.861 5.277)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_37097",
    "data-name": "Path 37097",
    d: "M68.261-44.88H54.691A1.224,1.224,0,0,1,53.467-46.1V-59.675A1.224,1.224,0,0,1,54.691-60.9h13.57a1.225,1.225,0,0,1,1.224,1.224V-46.1A1.225,1.225,0,0,1,68.261-44.88ZM55.915-47.328H67.037V-58.451H55.915Z",
    transform: "translate(-19.967 -20.002)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_37102",
    "data-name": "Path 37102",
    d: "M333.278,258.96a3.4,3.4,0,0,0-2.939,1.7l-24.629,42.66a3.394,3.394,0,0,0,2.939,5.092h32.476a13.838,13.838,0,0,1,13.813-13.535c.361,0,.717.027,1.071.056l-19.791-34.272A3.4,3.4,0,0,0,333.278,258.96Zm2.471,40.634a3.475,3.475,0,1,1,1.024-2.469A3.49,3.49,0,0,1,335.749,299.594Zm.884-24.937L334.487,289.2a1.239,1.239,0,0,1-1.2,1.323c-.77,0-1.149-.392-1.193-1.238l-2.153-14.628a2.848,2.848,0,0,1,.652-2.2,4.082,4.082,0,0,1,5.388,0A2.89,2.89,0,0,1,336.633,274.657Z",
    transform: "translate(-38.061 -193.733)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverdueWarning);
export default __webpack_public_path__ + "static/media/overdue-warning.15402c6c0dd15722b495c55f4bba6b90.svg";
export { ForwardRef as ReactComponent };